import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Account } from '../models/account';
import { NGaugeService } from './shared/ngauge.service';
interface BroadcastEvent {
  key: any;
  data?: any;
}
@Injectable()
export class AccountService {
  private _eventBus: Subject<BroadcastEvent>;
  user_rates = new Subject();
  accountDetails: any;
  map: Map<String, Object>;

  constructor(private httpClient: HttpClient, private ngaugeService: NGaugeService) {
    this.accountDetails = '';
    this._eventBus = new Subject<BroadcastEvent>();
    this.map = new Map();
  }

  broadcast(key: any, data?: any) {
    this._eventBus.next({ key, data });
  }

  on<T>(key: any): Observable<T> {
    return this._eventBus.asObservable()
      .filter(event => event.key === key)
      .map(event => <T>event.data);
  }

  setUserRates(user_rates: any) {
    this.user_rates.next(user_rates);
  }

  getUserRates() {
    return this.user_rates.asObservable();
  }

  setAccount(account) {
    this.accountDetails = account;
  }

  getAccountDetails(): Account {
    return this.accountDetails;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/account.service.ts